import { render, staticRenderFns } from "./BaseConfirmModal.vue?vue&type=template&id=22e4338c&"
import script from "./BaseConfirmModal.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports